import { type FC } from 'react';
import type { ViewBox } from 'recharts/types/util/types';

export const LABEL_STYLES = {
  CHAR_WIDTH: 6,
  PADDING: 3,
  HEIGHT: 13,
  VERTICAL_OFFSET: 7.5,
  FONT_SIZE: 10,
  BACKGROUND_FILL: 'var(--cxy-color-content-default)',
  TEXT_FILL: 'var(--cxy-color-reference-line-label, var(--cxy-color-content-contrast))',
} as const;

interface ReferenceLineLabelProps {
  value: number;
  viewBox?: ViewBox;
}

export const ReferenceLineLabel: FC<ReferenceLineLabelProps> = ({ value, viewBox }) => {
  if (!viewBox || !('x' in viewBox) || !('y' in viewBox) || !('width' in viewBox)) return null;

  const { width, x, y } = viewBox as { width: number; x: number; y: number };

  const boxWidth = value.toString().length * LABEL_STYLES.CHAR_WIDTH + LABEL_STYLES.PADDING;
  const labelX = x + width;
  const centerX = labelX + boxWidth / 2;

  return (
    <g>
      <rect
        fill={LABEL_STYLES.BACKGROUND_FILL}
        height={LABEL_STYLES.HEIGHT}
        rx={2}
        width={boxWidth}
        x={labelX}
        y={y - LABEL_STYLES.VERTICAL_OFFSET}
      />
      <text
        data-testid="reference-line-label"
        dominantBaseline="middle"
        fill={LABEL_STYLES.TEXT_FILL}
        fontSize={LABEL_STYLES.FONT_SIZE}
        fontWeight={600}
        textAnchor="middle"
        x={centerX}
        y={y}
      >
        {value}
      </text>
    </g>
  );
};
